import { ArkosConfig } from "../exports";
import { getUserFileExtension } from "./helpers/fs.helpers";
// import { PrismaClient } from "../types/global";

/**
 * Defines and validates the Arkos configuration, filling in defaults where needed.
 * Use this in your `arkos.config.ts` to get full type safety and autocompletion.
 *
 * @example
 * ```ts
 * // arkos.config.ts
 * import { defineConfig } from "arkos/config";
 *
 * export default defineConfig({
 *   globalPrefix: "/api",
 * });
 * ```
 *
 * @see {@link https://www.arkosjs.com/docs/reference/define-config}
 */
export function defineConfig(config: ArkosConfig) {
  // if (!config.prisma?.instance) {
  //   throw new Error(
  //     "ArkosConfigError: prisma.instance is required. Pass your PrismaClient instance via defineConfig({ prisma: { instance: new PrismaClient() } })."
  //   );
  // }

  // if (!(config.prisma.instance instanceof PrismaClient)) {
  //   throw new Error(
  //     "ArkosConfigError: prisma.instance must be a valid PrismaClient instance."
  //   );
  // }

  const finalConfig: Partial<ArkosConfig> = {
    welcomeMessage:
      "Welcome to our RESTful API generated by Arkos, find out more about Arkos at www.arkosjs.com",
    globalPrefix: "/api",
    ...config,
    source: {
      entryPoint: `src/app.${getUserFileExtension()}`,
      ...config.source,
    },
    port:
      config.port ||
      Number(process.env.__PORT || process.env.CLI_PORT || process.env.PORT) ||
      8000,
    host:
      config.host ||
      process.env.__HOST ||
      process.env.CLI_HOST ||
      process.env.HOST ||
      (process.env.ARKOS_BUILD !== "true" ? "0.0.0.0" : "127.0.0.1"),
    request: {
      ...config.request,
      parameters: {
        allowDangerousPrismaQueryOptions:
          config.request?.parameters?.allowDangerousPrismaQueryOptions ?? false,
        ...config.request?.parameters,
      },
    },
    fileUpload: {
      baseUploadDir: "uploads",
      baseRoute: "/api/uploads",
      ...config.fileUpload,
    },
    routers: {
      strict: config.routers?.strict || false,
      ...config.routers,
    },
    middlewares: {
      ...config.middlewares,
    },
    swagger: {
      ...config?.swagger,
      mode: config?.swagger?.mode || config?.validation?.resolver || "prisma",
      enableAfterBuild: config?.swagger?.enableAfterBuild !== false,
      authenticate:
        typeof config?.swagger?.authenticate === "boolean"
          ? config?.swagger?.authenticate
          : config?.swagger?.enableAfterBuild !== false
            ? process.env.ARKOS_BUILD === "true"
            : false,
    },
    debugging: {
      requests: {
        level: config.debugging?.requests?.level || 1,
        ...config.debugging?.requests,
      },
      dynamicLoader: {
        level: config.debugging?.dynamicLoader?.level || 0,
        ...config.debugging?.dynamicLoader,
      },
    },
  };

  (finalConfig as any).__loader = "defineConfig";

  return finalConfig;
}

export type UserArkosConfig = ReturnType<typeof defineConfig> & {
  __loader: "defineConfig";
};
